import __vue_component__ from '../HseIcon/HseIcon.vue.js';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import 'reflect-metadata';
import { BlockquoteVariant } from './BlockquoteVariant.js';
import __vue_component__$1 from '../HsePerson/HsePerson.vue.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=9384%3A0
 * @storybook /?path=/story/content-content--playground
 * @react /src-components-blockquote
 * @reactStorybook /?path=/story/content-content--playground
 */
var HseBlockquote = /** @class */ (function (_super) {
    __extends(HseBlockquote, _super);
    function HseBlockquote() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(HseBlockquote.prototype, "BlockquoteVariant", {
        get: function () {
            return BlockquoteVariant;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseBlockquote.prototype, "author", void 0);
    __decorate([
        Prop({
            default: ''
        }),
        __metadata("design:type", String)
    ], HseBlockquote.prototype, "avatarUrl", void 0);
    __decorate([
        Prop({
            default: function () { return ({
                left: '',
                avatar: '',
                personClasses: {},
                right: '',
                author: '',
                content: '',
            }); }
        }),
        __metadata("design:type", Object)
    ], HseBlockquote.prototype, "classes", void 0);
    __decorate([
        Prop(EnumProp(BlockquoteVariant.normal, BlockquoteVariant)),
        __metadata("design:type", String)
    ], HseBlockquote.prototype, "variant", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseBlockquote.prototype, "hasMargin", void 0);
    HseBlockquote = __decorate([
        Component({
            name: 'HseBlockquote',
            components: {
                HseIcon: __vue_component__,
                HsePerson: __vue_component__$1
            }
        })
    ], HseBlockquote);
    return HseBlockquote;
}(Vue));

export default HseBlockquote;
